export default "__VITE_ASSET__Bdihdg6p__"